/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.events-sidebar {
  display: grid;
  grid-template-rows: auto auto 1fr;
  grid-template-areas: 'header' 'quick-buttons' 'timeline';
  width: 100%;
  height: 100%;

  padding-top: variables.$padding-medium;

  .header {
    grid-area: header;
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .quick-buttons {
    grid-area: quick-buttons;
    .quick-button {
      background-color: variables.$color-lightgrey;
      width: 40px;
      height: 40px;
      border-radius: 4px;
      margin: variables.$margin-small;
    }

    .add-button {
      background-color: variables.$color-primary-50;
      color: variables.$color-primary;
      width: 40px;
      height: 40px;
      border-radius: 4px;
      margin: variables.$margin-small;
    }

    .quick-button-icon {
      width: 20px;
      height: 20px;
    }
  }

  .event-timeline {
    grid-area: timeline;
    padding: variables.$padding-medium 0 0 0;
    min-height: 100px;
    height: 100%;
  }

  .event-timeline .event {
    list-style: none;
    margin-left: variables.$margin-large;
    width: 200px;
    min-height: 50px;
    border-left: 1px solid #bdbdbd;
    padding: 0 0 40px 24px;
    position: relative;
  }

  .event-timeline .event:last-child {
    // Remove the border below the last event
    // Use transparent instead of none so that the event is aligned the same as the others
    border-left: 1px solid rgba(0, 0, 0, 0);
  }

  // Black circle left of the event
  .event-timeline .event::before {
    position: absolute;
    left: -16px;
    top: 0;
    height: 19px;
    width: 19px;
    background: variables.$color-black;
    content: ' ';
    // Use white border to generate the spacing around the vertical line
    border: 6px solid variables.$color-white;
    border-radius: 99px;
  }

  .event-timeline .event:last-child::before {
    left: -15px;
    top: 2px;
    height: 13px;
    width: 13px;
    border: 8px double variables.$color-white;
  }

  .event-timestamp {
    color: variables.$color-black-60;
    font-size: 14px;
  }
}
